<template>
    <h4 class="mt-0 mb-0">Project Phases</h4>
    <div class="row mb-3">
        <div class="col-md-2">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="addPhase()">Add Phase</button>
        </div>
    </div>

                    
    <div class="row" :key="renderPhases">
        <div class="col-md-12 row">
            <div class="col-md-3 mt-3" v-for="(phase, phaseKey) in phases" :key="phase.id">
                <div class="row single-phase">
                    <div class="col-md-12">
                        <label for="" class="form-label">Phase Name:</label>
                        <span class="remove-phase-icon" @click="deletePhase(phase.id, phaseKey)" title="Delete phase">
                            <i class="uil-times-circle"></i>
                        </span>
                        <span class="save-phase-icon" @click="savePhase(phase.id, phaseKey)" title="Save phase">
                            <i class="uil-check-circle"></i>
                        </span>
                        <input type="text" class="form-control" v-model="phases[phaseKey].name">
                    </div>

                    <div class="col-md-6 mt-2">
                        <label for="" class="form-label">From:</label>
                        <input type="date" class="form-control" v-model="phases[phaseKey].from">
                    </div>

                    <div class="col-md-6 mt-2">
                        <label for="" class="form-label">To:</label>
                        <input type="date" class="form-control" v-model="phases[phaseKey].to">
                    </div>

                    <div class="col-md-12 row mt-2">
                        <label for="" class="form-label">Members:</label>
                        <div class="col-md-12">
                            <div class="circular" v-for="(member, memberKey) in phase.members" :key="memberKey" :title="member.user.name">
                                <img v-if="member.user.image" class="profile-image" :src="'/' + member.user.image" alt="" @click="openMember(member, memberKey, phase.id, phaseKey)">
                                <img v-else class="profile-image" src="/images/team-placeholder.png" alt="" @click="openMember(member, memberKey, phase.id, phaseKey)">
                                
                            </div>
                            <div class="circular add-new-member" @click="addNewMember(phase.id, phaseKey)" title="Add member">
                                <i class="uil-plus-circle"></i>
                                <!-- <img class="profile-image" :src="'/' + member.user.image" alt="" > -->
                            </div>
                        </div>
                        
                    </div>

                </div>
            </div>
        </div>
        <div class="col-md-2">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="submitPhases()">Save</button>
        </div>
    </div>


    <!-- Modal member -->
    <div 
        class="modal fade"
        id="memberModal"
        tabindex="-1"
        aria-labelledby="member"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="member">
                        Phase Member
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>

                <div class="modal-body">

                    <div class="row">

                        <div class="col-md-12">
                            <label for="new_member" class="form-label">Member:</label>
                            <div class="input-group has-validation">
                                <select :class="{'form-select':true}" id="new_phase_member" v-model="phase_member_id">
                                    <option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-12 mt-3">
                            <label for="new_member" class="form-label">Days:</label>
                            <input type="text" class="form-control" v-model="phase_member_days">
                        </div>

                    </div>

                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Cancel
                    </button>
                    <button type="button" v-if="phase_member.id" @click="savePhaseMember()" class="btn btn-primary">
                        Save
                    </button>
                    <button type="button" v-else @click="addPhaseMember()" class="btn btn-primary">
                        Save
                    </button>

                    <button type="button" v-if="phase_member.id" @click="removePhaseMember(phase_member, phase_member_key)" class="btn btn-danger">
                        Remove
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from 'bootstrap';

export default {
    props: {
        project: Object,
        users: Object
    },
    data() {
        return {
            modal: null,
            phases: [],
            phase_member: {},
            phase_member_id: null,
            phase_member_days: null,
            phase_member_key: null,
            renderPhases: 0,
            phase_id: null,
            phase_key: null
        }
    },
    methods: {
        formatDate (date) {
            return moment(date).format('Do MMM YYYY')
        },
        edit(project) {
            this.projectToEdit = project;
            
            this.isEdit = true;
            this.isOpen = true;
        },
        addNew () {
            this.project = null;
            
            this.isEdit = false;
            this.isOpen = true;
        },
        confirnDelete(project) {
            this.project = project;
            this.showConfirmBox = true;
        },
        modalStatus(status) {
            this.isOpen = status;
        },
        hideConfirmation() {
            this.showConfirmBox = false;
        },
        openMember (member, key, phaseID, phaseKey) {
            this.phase_member = member
            this.phase_member_id = member.user_id
            this.phase_member_key = key
            this.phase_member_days = member.days

            this.phase_id = phaseID
            this.phase_key = phaseKey

            this.modal.show();
        },
        addNewMember (phaseID, phaseKey) {
            this.phase_member = {}
            this.phase_member_id = null
            this.phase_member_key = null
            this.phase_member_days = null

            this.phase_id = phaseID
            this.phase_key = phaseKey

            this.modal.show();
        },
        submitPhases () {
            console.log(phases)
        },
        async deletePhase (id, key) {
            if(confirm("Do you really want to delete?")){
                try {
                    const response = await axios.post('/project/delete-phase', {
                        id: id
                    }); // Replace with your actual endpoint
                    console.log('Phase removed:', response.data);

                    this.phases.splice(key, 1)
                    
                    // Optionally, you can update your UI or perform other actions here
                } catch (error) {
                    console.error('Error removing member:', error);
                }
            }
        },
        async addPhase () {
            try {
                const response = await axios.post('/project/add-phase', {
                    project_id: this.project.id
                }); // Replace with your actual endpoint
                console.log('Phase added:', response.data);

                let newPhase = {
                    id: response.data.data.id,
                    project_id: this.project.id,
                    from: response.data.data.from,
                    to: response.data.data.to,
                    name: "", 
                    members: []
                }

                this.phases.push(newPhase)
                console.log(this.phases)
                // Optionally, you can update your UI or perform other actions here
            } catch (error) {
                console.error('Error adding member:', error);
            }
        },
        async savePhase (id, key) {
            try {
                const response = await axios.post('/project/save-phase', {
                    from: this.phases[key].from,
                    to: this.phases[key].to,
                    name: this.phases[key].name,
                    id: id
                }); // Replace with your actual endpoint
                console.log('Phase saved:', response.data);
                // Optionally, you can update your UI or perform other actions here
            } catch (error) {
                console.error('Error saving phase:', error);
            }
        },
        async addPhaseMember (id) {
            try {
                const response = await axios.post('/project/add-phase-member', {
                    user_id: this.phase_member_id,
                    days: this.phase_member_days,
                    project_phase_id: this.phase_id
                }); // Replace with your actual endpoint
                console.log('Member added:', response.data);
                let newMember = {
                    user_id: this.phase_member_id,
                    project_phase_id: this.phase_id,
                    days: this.phase_member_days,
                    user: this.users[this.phase_member_id]
                }

                this.phases[this.phase_key].members.push(newMember)
                this.modal.hide();
                // Optionally, you can update your UI or perform other actions here
            } catch (error) {
                console.error('Error adding member:', error);
            }
        },
        async removePhaseMember (id, key) {
            try {
                const response = await axios.post('/project/remove-phase-member', {
                    id: this.phase_member.id
                }); // Replace with your actual endpoint
                console.log('Member removec:', response.data);

                this.phases[this.phase_key].members.splice(key, 1)

                this.modal.hide();
                // Optionally, you can update your UI or perform other actions here
            } catch (error) {
                console.error('Error removing member:', error);
            }
        },
        async savePhaseMember () {
            try {
                const response = await axios.post('/project/edit-phase-member', {
                    user_id: this.phase_member_id,
                    days: this.phase_member_days,
                    project_phase_id: this.phase_id
                }); // Replace with your actual endpoint
                console.log('Member added:', response.data);
                
                this.phases[this.phase_key].members[this.phase_member_key].days = this.phase_member_days
                this.modal.hide();
                // Optionally, you can update your UI or perform other actions here
            } catch (error) {
                console.error('Error adding member:', error);
            }
        },
    },

    computed: {
        deleteConfirmation() {
            return `Are you sure went to delete ${this.project.name}?`;
        },
    },
    mounted() {
        if (this.project.phases) this.phases = this.project.phases

        var modalEl = document.getElementById('memberModal')
        this.modal = new Modal(modalEl)
        
    },
    updated() {
    },
};
</script>

<style scoped>
    .row.single-phase {
        padding: 13px 3px;
        border: 1px solid #e2e2e2;
        border-radius: 5px;
        margin-left: 0;
    }

    .save-phase-icon {
        font-size: 16px;
        color: rgb(52, 153, 24);
        cursor: pointer;
        float: right;
    }

    .remove-phase-icon {
        font-size: 16px;
        color: red;
        cursor: pointer;
        float: right;
    }

    .profile-image {
        cursor: pointer;
    }

    .add-new-member {
        font-size: 32px;
        cursor: pointer;
    }
</style>